import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DfModuleImageModule } from '@df/module-image/df-module-image.module';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { UndefinedOption } from '@df/ui/atomic/atomic-options';
import { MediaModule } from '@df/ui/display/media/media.module';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { NTextBox, TextBoxComponent } from '../../common/text-box/text-box.component';

export namespace NCmsEditorial {
    export interface IComponentData extends NICmsContentComponent.IData {
        //Text
        textPosition: 'right' | 'left';
        fewImages: boolean;
        images: IImage[];
    }

    export interface IImage {
        //Video&Image
        videoProvider?: 'youtube' | 'vimeo';
        videoId?: string;
        videoAutoplay: boolean;
        videoBackground: boolean;
        backgroundImage?: string;
    }
}

@ICmsComponent<CmsEditorialComponent>({
    id: 'editorial',
    name: 'Editorial',
    tags: ['video', 'image', 'editorial'],
    isAdvanced: true,
    fields: [
        // Text
        <NICmsContentField.IChoiceField>{
            key: 'textPosition',
            type: NICmsContentField.EFieldType.choice,
            title: 'Text position',
            options: [
                { key: 'right', title: 'Right/Bottom' },
                { key: 'left', title: 'Left/Top' }
            ],
            default: 'right',
            required: true
        },
        ...NTextBox.getFields(false, true),
        {
            key: 'fewImages',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Multiple images',
            default: false,
            required: true
        },
        // Video&Image
        {
            type: NICmsContentField.EFieldType.label,
            key: 'section-content',
            title: 'Content'
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'images',
            title: 'Images',
            itemName: 'Image',
            required: true,
            maxSize: (data: NCmsEditorial.IComponentData) => (data.fewImages ? 3 : 1),
            fields: [
                {
                    type: NICmsContentField.EFieldType.label,
                    key: 'section-video',
                    title: 'Video'
                },
                <NICmsContentField.IChoiceField>{
                    key: 'videoProvider',
                    type: NICmsContentField.EFieldType.choice,
                    title: 'Video Provider',
                    options: [
                        ...UndefinedOption,
                        {
                            key: 'youtube',
                            title: 'YouTube'
                        },
                        {
                            key: 'vimeo',
                            title: 'Vimeo'
                        }
                    ],
                    description: 'Choose a video provider'
                },
                {
                    key: 'videoId',
                    type: NICmsContentField.EFieldType.text,
                    title: 'ID or URL',
                    description: 'Video ID or URL',
                    default: ''
                },
                {
                    key: 'videoBackground',
                    type: NICmsContentField.EFieldType.toggle,
                    title: 'Background Mode',
                    default: true,
                    required: true
                },
                {
                    key: 'videoAutoplay',
                    type: NICmsContentField.EFieldType.toggle,
                    title: 'Autoplay',
                    default: true,
                    required: true
                    // canShow: (data: NCmsEditorial.IComponentData) => !data.videoBackground
                },
                {
                    type: NICmsContentField.EFieldType.label,
                    key: 'section-image',
                    title: 'Background image'
                },
                {
                    key: 'backgroundImage',
                    type: NICmsContentField.EFieldType.image,
                    title: 'Background image',
                    default: undefined
                }
            ]
        },
        NICmsContentComponent.backgroundField
    ]
})
@Component({
    standalone: true,
    imports: [TextBoxComponent, CommonModule, GridModule, MediaModule, DfModuleImageModule],
    selector: 'cms-editorial',
    templateUrl: './cms-editorial.html',
    styleUrl: './cms-editorial.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsEditorialComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component?: NCmsEditorial.IComponentData;
}
